(() => {
    const searchRelatedScope = '[data-filter-scope="search"], [data-filter-scope="related"]';

    /* Nur bei AS die Filter von Suche und Related inklusive ihrer Spalte entfernen. */
    function removeAsFilters(root) {
        const removeFilter = element => {
            const scope = element.closest(searchRelatedScope);
            if (scope?.closest('.theme-as')) {
                element.remove();
            }
        };

        if (root instanceof HTMLElement && root.matches('[data-filter-ui]')) {
            removeFilter(root);
        }
        root.querySelectorAll('[data-filter-ui]').forEach(removeFilter);
    }

    /* Prüft, ob aktuell mindestens ein Filter sichtbar ist */
    const isAnyFilterOpen = () =>
        Array.from(document.querySelectorAll('[data-filter-block]'))
             .some(b => !b.classList.contains('-left-[20rem]'));

    /* Öffnet oder schließt einen Filter */
    function toggleBlock(block, open) {
        if (!block) return;

        block.classList.toggle('left-0', open);
        block.classList.toggle('-left-[20rem]', !open);
    }

    /* Globaler Klick-Listener (Event Delegation) */
    document.addEventListener('click', e => {
        /* Klick auf Filter-Button */
        const filterBtn = e.target.closest('[data-action="show-filter"]');
        if (filterBtn) {
            e.stopPropagation();

            const target = filterBtn.dataset.target;

            /* Ziel-Filter öffnen, alle anderen schließen */
            document.querySelectorAll('[data-filter-block]').forEach(block => {
                toggleBlock(block, block.dataset.filterBlock === target);
            });
            return;
        }

        /* Klick auf Close-Button */
        const closeBtn = e.target.closest('.iww-close');
        if (closeBtn) {
            e.stopPropagation();
            toggleBlock(closeBtn.closest('[data-filter-block]'), false);
            return;
        }

        /* Klick innerhalb eines Filters → nichts schließen */
        if (e.target.closest('[data-filter-block]')) {
            e.stopPropagation();
            return;
        }

        /* Klick außerhalb → alle offenen Filter schließen */
        if (!isAnyFilterOpen()) return;

        document.querySelectorAll('[data-filter-block]').forEach(block => {
            if (!block.classList.contains('-left-[20rem]')) {
                toggleBlock(block, false);
            }
        });
    });

    /* Beobachtet dynamische DOM-Änderungen (HTMX, JS, etc.) */
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return;

                removeAsFilters(node);
                if (!node.isConnected) return;

                /* Falls der Node selbst ein Filter ist */
                if (node.matches?.('[data-filter-block]')) {
                    toggleBlock(node, false);
                }

                /* Falls Filter innerhalb des Nodes liegen */
                node.querySelectorAll?.('[data-filter-block]').forEach(block => {
                    toggleBlock(block, false);
                });
            });
        });
    });

    function initialize() {
        removeAsFilters(document);
        document.querySelectorAll('[data-filter-block]').forEach(block => toggleBlock(block, false));
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
        initialize();
    }
})();
